import { useImperativeHandle } from 'react'
import { useForm } from 'react-hook-form'

const useUserForm = function ({ currentOrg = {} }, ref) {
  const {
    watch,
    control,
    register,
    formState: { errors },
    formState,
    setValue,
    getValues,
    trigger,
    clearErrors,
    reset,
  } = useForm({
    defaultValues: currentOrg,
    reValidateMode: 'onChange',
  })

  if (ref) {
    useImperativeHandle(ref, () => ({
      getValues,
      trigger,
    }))
  }

  return {
    reset,
    watch,
    control,
    register,
    formState,
    errors,
    setValue,
    getValues,
    clearErrors,
  }
}

export default useUserForm
